import React from 'react'
import PropTypes from 'prop-types'
import Autosuggest from 'react-autosuggest'
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import { Avatar, Grid, ListItemText, MenuItem, Switch, FormControlLabel, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { debounce, find } from 'lodash'
import UserStore from '../stores/UserStore'
import AttachUsers from './AttachUsers'
import extract_user from '../functions/extract'

function renderInput (inputProps) {
  const {classes, disabled, ref, ...other} = inputProps

  return (
    <TextField
      fullWidth
      inputRef={ref}
      disabled={disabled}
      InputProps={{
        classes: {
          input: classes.input
        },
        ...other
      }}
    />
  )
}

function renderSuggestion (suggestion, {query, isHighlighted}) {
  let fullName = suggestion.name.title+' '+suggestion.name.full
  if(suggestion.job_title !== '') fullName += '-('+suggestion.job_title+')'
  const matches = match(fullName, query)
  const parts = parse(fullName, matches)

  return (
    //if there is no photo the assumtion  is a group, when is a user the server MUST return an url
    <MenuItem selected={isHighlighted} component="div">
        <Avatar alt="avatar" className="avatar">{suggestion.name.full.slice(0,2)}</Avatar>
      <ListItemText style={{overflow: 'auto'}}
                    primary={parts.map((part, i) => {
                      return part.highlight ? (
                        <span key={String(i)} style={{fontWeight: 500}}>
              {part.text}
            </span>
                      ) : (
                        <strong key={String(i)} style={{fontWeight: 300}}>
                          {part.text}
                        </strong>
                      )
                    })}
                    secondary={(typeof(suggestion.email) !== 'undefined') ?  extract_user(suggestion.email) : ''}
      />
    </MenuItem>
  )
}

function renderSuggestionsContainer (options) {
  const {containerProps, children} = options

  return (
    <Paper {...containerProps} square style={{ maxHeight: 400, overflowY: 'scroll' }}>
      {children}
    </Paper>
  )
}

function getSuggestionValue (guy) {
  return guy.name.full
}

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative'
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0
  },
  suggestion: {
    display: 'block'
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  },
  adornment: {
    whiteSpace: 'nowrap'
  },
  inputText: {
    fontSize: '14px'
  }
})

class SearchUserFieldChip extends React.Component {
  handleSuggestionsFetchRequested = debounce(({value}) => {
    if(value.length > 2){
      UserStore.search(value, this.props.includeGroups).then(r => {
        this.setState({
          suggestions: r.data
        })
      })
    }

  }, 500)
  onBlur = () => {
    let full = find(this.state.psugges, {name: {full: this.state.value}})
    if (full === undefined) {
      full = find(this.state.suggestions, {name: {full: this.state.value}})
      if (full === undefined) this.setState({value: ''})
    }
  }

  handleSuggestionsClearRequested = () => {
    this.setState({value: ''})
    this.setState(prev => {
      prev.psugges = prev.suggestions
      prev.suggestions = []
      return prev
    })
  }

  handleChange = (event, {newValue}) => {
    this.setState({
      value: newValue
    })
  }

  constructor (props) {
    super(props)
    this.state = {
      value: '',
      suggestions: [],
      external: false,
      ext_name: '',
      ext_job_title: ''
    }
  }

changeTypeAddressee = () => {
  this.setState({ external: !this.state.external })
  this.resetAddresseeValues();
}

addAddressee = () => {
  // this.props.onAddCC(this.state.ext_name, this.state.ext_job_title)
  this.props.onAddExternalCC(this.state.ext_name, this.state.ext_job_title)
  this.setState({ external: false })
  this.resetAddresseeValues();
}

resetAddresseeValues = () => {
  this.setState({
    ext_name: '',
    ext_job_title: ''
  })
}

onChangeAddressee = (value, field) => {
  this.setState(ps => {
    const ns = { ...ps };
    ns[field] = value;
    return ns;
  });
}

  render () {
    const {classes, ccList, onAddCC, onDeleteCC, ccNote, onCcNoteChange, alreadyAdded} = this.props;
    const { external, ext_name, ext_job_title } = this.state;

    let section_addressee = (
      <Grid item sm={8} md={8} lg={8} xs={12}>
        <Autosuggest
          theme={{
            container: classes.container,
            suggestionsContainerOpen: classes.suggestionsContainerOpen,
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion
          }}
          renderInputComponent={renderInput}
          suggestions={this.state.suggestions}
          onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
          renderSuggestionsContainer={renderSuggestionsContainer}
          getSuggestionValue={getSuggestionValue}
          onSuggestionSelected={onAddCC}
          renderSuggestion={renderSuggestion}
          inputProps={{
            classes,
            placeholder: 'Buscar usuario',
            value: this.state.value,
            onChange: this.handleChange,
            onBlur: this.onBlur,
            disabled: this.props.disabled,

          }}
        />
      </Grid>
    );

    if(external){
      section_addressee = (
      <React.Fragment>
        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
          <TextField
            placeholder="Nombre con titulo"
            value={ext_name}
            fullWidth
            InputProps={{
              classes: {
                input: classes.input
              },
            }}
            onChange={e => {
              this.onChangeAddressee(e.target.value, "ext_name");
            }}
          />
        </Grid>
        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
          <TextField
            placeholder="Puesto"
            value={ext_job_title}
            fullWidth
            InputProps={{
              classes: {
                input: classes.input
              },
            }}
            onChange={e => {
              this.onChangeAddressee(e.target.value, "ext_job_title");
            }}
          />
        </Grid>
        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
          <Button
            disabled={ext_name.length > 0? false : true}
            className="button_modal_medium"
            onClick={this.addAddressee}
            color="primary"
            size="small"
          >
            Agregar
          </Button>
        </Grid>
      </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <Grid container direction="row" spacing={40} alignItems="flex-end">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding: '0px 20px' }}>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.external}
                  onChange={this.changeTypeAddressee}
                  name="external"
                  color="primary"
                />}
                label="Destinatario externo"
              />
          </Grid>
          {section_addressee}
          <Grid item sm={4} md={4} lg={4} xs={12}>
            <TextField
              placeholder="Agregar nota"
              fullWidth
              value={ccNote}
              onChange={e => {
                onCcNoteChange(e.target.value)
              }}
              disabled={ccList.length === 0}
              className='input_disabled'
              multiline
              inputProps={{
                maxLength: 200,                
              }}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <AttachUsers
              open={this.closeSth}
              onClose={this.toggleUpload}
              onChange={this.closeSth}
              onDelete={this.onDeleteUser}
              readOnly={false}
              isUploading={this.isUploading}
              ccList={ccList}
              onDeleteCC={onDeleteCC}
              alreadyAdded={alreadyAdded}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    )
  }
}

SearchUserFieldChip.defaultProps = {includeGroups: false}

SearchUserFieldChip.propTypes = {
  // onChange: PropTypes.func.isRequired,
  includeGroups: PropTypes.bool.isRequired,
  onAddCC: PropTypes.func.isRequired,
  onAddExternalCC: PropTypes.func.isRequired,
  onDeleteCC: PropTypes.func.isRequired,
  ccNote: PropTypes.string.isRequired,
  onCcNoteChange: PropTypes.func.isRequired
}

export default withStyles(styles)(SearchUserFieldChip)



// WEBPACK FOOTER //
// ./src/components/SearchUserChipField.js